var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useFeatureFlags } from '../hooks';
export var withFeatureFlags = function (WrappedComponent) {
    var WithFeatureFlags = function (props) {
        var featureFlags = useFeatureFlags();
        return _jsx(WrappedComponent, __assign({}, props, { featureFlags: featureFlags }));
    };
    WithFeatureFlags.displayName = "WithFeatureFlags(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
    return WithFeatureFlags;
};
/**
 * Use this HOC to inject specific feature flags into a component's props.
 */
export var withInjectFeatureFlagsToProps = function (flagNames) {
    if (flagNames === void 0) { flagNames = []; }
    return function (WrappedComponent) {
        var WithInjectFeatureFlagsToProps = function (props) {
            var featureFlags = useFeatureFlags();
            var injectedFlags = flagNames.reduce(function (acc, flag) {
                var _a;
                var flagName = typeof flag === 'string' ? flag : flag.name;
                var propName = typeof flag === 'string' ? flag : flag.as;
                return __assign(__assign({}, acc), (_a = {}, _a[propName] = featureFlags[flagName], _a));
            }, {});
            return _jsx(WrappedComponent, __assign({}, props, injectedFlags));
        };
        WithInjectFeatureFlagsToProps.displayName = "WithInjectFeatureFlagsToProps(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
        return WithInjectFeatureFlagsToProps;
    };
};
